import React from 'react';

// components
import CueTag from '../CueTag';

// store
import { useCommCenter } from '../../context';

/**
 * Renders a segment list as inline content: plain copy, bold actor names,
 * project links, user mentions and clickable cue tags.
 *
 * Segment kinds, as produced by adapters.js:
 *   { k: 'text',    v }                            plain copy
 *   { k: 'strong',  v }                            actor name (semibold)
 *   { k: 'em',      v }                            emphasised copy (medium)
 *   { k: 'project', v, projectId }                 project link
 *   { k: 'mention', v, userId }                    user mention
 *   { k: 'cue',     code, instrument, cueId }      cue tag with instrument icon
 */
const RichText = ({ segments = [] }) => {
    const { resolveProject, openProject, openCue, openMention } = useCommCenter();

    return (
        <>
            {segments.map((segment, i) => {
                const key = `${segment.k}-${i}`;

                switch (segment.k) {
                    case 'strong':
                        return <strong key={key} className="richText__actor">{segment.v}</strong>;

                    case 'em':
                        return <span key={key} className="richText__em">{segment.v}</span>;

                    case 'project': {
                        const ref = segment.projectId ?? segment.ref;
                        const project = resolveProject(ref, segment.v);

                        return (
                            <button
                                key={key}
                                type="button"
                                className="richText__link"
                                onClick={() => openProject(ref, segment.v)}>
                                {project.name}
                            </button>
                        );
                    }

                    case 'mention':
                        return (
                            <button
                                key={key}
                                type="button"
                                className="richText__mention"
                                onClick={() => openMention(segment)}>
                                {segment.v}
                            </button>
                        );

                    case 'cue':
                        return (
                            <CueTag
                                key={key}
                                code={segment.code}
                                instrument={segment.instrument}
                                onClick={() => openCue(segment)}/>
                        );

                    default:
                        return <React.Fragment key={key}>{segment.v}</React.Fragment>;
                }
            })}
        </>
    )
}

export default RichText;
